import React from 'react';
import { CalendarClockIcon, CreditCardIcon, FolderOpenIcon, GiftIcon, LockIcon, ReceiptIcon, RefreshCwIcon, ScanSearchIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
const CHECKOUT_URL = 'https://librofy-store.myshopify.com/cart/47910701957341:1';
const included = [{
  icon: ScanSearchIcon,
  title: 'Scanner de Encuadre RG 5866',
  value: '$10.000',
  core: true
}, {
  icon: ShieldCheckIcon,
  title: 'Protocolo de Blindaje y Notificación',
  value: '$9.000'
}, {
  icon: CalendarClockIcon,
  title: 'Tablero de Control de Vencimientos 2026/2027',
  value: '$9.000'
}, {
  icon: FolderOpenIcon,
  title: 'Kit de Documentación de Respaldo Profesional',
  value: '$9.000'
}, {
  icon: RefreshCwIcon,
  title: 'Actualización Normativa Automática · 12 meses',
  value: '$8.000'
}];
export function PricingOffer() {
  return <section id="precio" className="w-full scroll-mt-4 bg-alt" data-id="element-150" data-mp="y8g4lagi6fpz">
      <div className="mx-auto max-w-2xl px-5 py-16 md:py-20" data-id="element-151" data-mp="1dq086ok1uw2i">
        <SectionReveal className="text-center" data-id="element-152" data-mp="1hq0ko3nl8x6x">
          <span className="inline-flex items-center rounded-full bg-accent/15 px-4 py-1.5 text-xs font-medium uppercase tracking-badge text-accent-dark" data-id="element-153" data-mp="1hpqvgiadau2a">
            ⏰ Precio de lanzamiento · Las aseguradoras entran en septiembre de
            2026
          </span>
          <p className="mt-5 text-xs font-bold uppercase tracking-badge text-blue" data-id="element-154" data-mp="u0fyzd01vlty">
            Sistema Operativo Premium
          </p>
          <h2 className="mt-2 text-2xl font-black leading-tight text-ink sm:text-3xl md:text-4xl" data-id="element-155" data-mp="ysplsk5vc5s0">
            Estudio Blindado — Edición RG 5866
          </h2>
        </SectionReveal>

        <SectionReveal delay={0.1} data-id="element-156" data-mp="pzw1g8bkeg7a">
          <article className="mt-8 rounded-3xl border-2 border-accent bg-base p-6 shadow-xl shadow-ink/5 sm:p-8" data-id="element-157" data-mp="pwqcct2xrebk">
            <header className="text-center" data-id="element-158" data-mp="g0new0j143uy">
              <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-xl bg-blue/10 text-blue" data-id="element-159" data-mp="fzltb24dzyyz">
                <ReceiptIcon className="h-5 w-5" strokeWidth={2.2} aria-hidden="true" data-id="element-160" data-mp="3t30ods4jhu4v" />
              </span>
              <h3 className="mt-4 text-xl font-black tracking-tight text-ink" data-id="element-161" data-mp="3jco666k76d1w">
                Estudio Blindado 
              </h3>
              <p className="mt-1 text-sm text-ink-soft" data-id="element-162" data-mp="3eap3z0071m6j">
                Sistema digital completo · Un solo pago · Acceso inmediato
              </p>
              <p className="mt-2 text-xs font-medium text-ink-soft" data-id="element-163" data-mp="ax4g1getpar2">
                ⭐ 4.9/5 · +500 contadores ya lo usan
              </p>
            </header>

            <ul className="mt-7 space-y-3.5" data-id="element-164" data-mp="xx48xnqlo62">
              {included.map(({
              icon: Icon,
              title,
              value,
              core
            }) => <li key={title} className="flex items-center gap-3" data-id="element-165" data-mp="2qnqnw3fzkg95">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-blue/10 text-blue" data-id="element-166" data-mp="2qkupyf451rkp">
                    <Icon className="h-4 w-4" strokeWidth={2.25} aria-hidden="true" data-id="element-167" data-mp="116dc5pvp6cgd" />
                  </span>
                  <div className="min-w-0 flex flex-1 items-center gap-2" data-id="element-168" data-mp="1b4jaxym7j2h0">
                    <span className="text-[14px] font-medium leading-snug text-ink sm:text-[15px]" data-id="element-169" data-mp="1b26mr3puvvvi">
                      {title}
                    </span>
                    {core && <span className="hidden shrink-0 rounded-full bg-accent/10 px-2 py-0.5 text-[10px] font-bold text-accent-dark sm:inline-flex" data-id="element-170" data-mp="1ktszx5lr850w">
                        ★ Núcleo del sistema
                      </span>}
                  </div>
                  <span className="shrink-0 text-xs font-medium text-strike line-through" data-id="element-171" data-mp="1ysssgoce142c">
                    {value}
                  </span>
                </li>)}
            </ul>
            <div className="mt-3 flex justify-end sm:hidden" data-id="element-172" data-mp="4gvuecjfwzyb">
              <span className="rounded-full bg-accent/10 px-2 py-0.5 text-[10px] font-bold text-accent-dark" data-id="element-173" data-mp="1uwy86g5yee1z">
                ★ Núcleo del sistema
              </span>
            </div>
            <p className="mt-5 text-right text-xs font-medium text-strike line-through" data-id="element-174" data-mp="1q07oliuxx0bt">
              Valor total: $45.000 ARS
            </p>

            <div className="mt-6 rounded-2xl border-2 border-dashed border-accent/45 bg-[#FFF6ED] p-5" data-id="element-175" data-mp="1zx2ni2v4l2qm">
              <div className="flex items-start gap-3" data-id="element-176" data-mp="1c7i2lefevvep">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent/10 text-accent" data-id="element-177" data-mp="177c87qhrbusx">
                  <GiftIcon className="h-4 w-4" strokeWidth={2.3} aria-hidden="true" data-id="element-178" data-mp="1kzabvlsp8yhp" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-179" data-mp="si7pm871voka">
                  <p className="text-[15px] leading-relaxed text-ink" data-id="element-180" data-mp="sgwlu8dlugt6">
                    <span className="font-bold" data-id="element-181" data-mp="ohnoktjcw0sv">REGALO: </span>
                    Asistente de Consultas Rápidas (WhatsApp) — 12 respuestas
                    técnicas definitivas listas para copiar y pegar.
                  </p>
                  <p className="mt-2 text-right text-xs font-bold text-accent" data-id="element-182" data-mp="j4ytfu2cpv7a">
                    Valor: $5.000 — Incluido gratis hoy
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 border-t-2 border-accent/20 bg-alt/50 px-4 pt-7 pb-1 text-center" data-id="element-183" data-mp="9bqf8ppq1zii">
              <span className="inline-flex rounded-full bg-accent/15 px-3 py-1 text-xs font-bold uppercase tracking-badge text-accent-dark" data-id="element-184" data-mp="x1cetea0agr1">
                Precio de lanzamiento
              </span>
              <p className="mx-auto mt-4 max-w-md text-[15px] font-bold leading-relaxed text-ink" data-id="element-185" data-mp="n7lpy89yw4at">
                Recuperar una jornada de trabajo administrativo te cuesta menos
                que una hora de tus honorarios.
              </p>
              <div className="mt-4" data-id="element-186" data-mp="3cutcy9gv61ag">
                <div className="flex items-center justify-center gap-2" data-id="element-187" data-mp="3cvut2scqldz1">
                  <p className="text-lg font-medium text-strike line-through" data-id="element-188" data-mp="1jaj28umq9ork">
                    $45.000 ARS
                  </p>
                  <span className="rounded-md bg-accent px-2 py-0.5 text-xs font-bold text-white" data-id="element-189" data-mp="1eeua3cd1fa5a">
                    -38%
                  </span>
                </div>
                <p className="mt-1 text-4xl font-black leading-none text-accent sm:text-5xl" data-id="element-190" data-mp="14m53ausfmkga">
                  $27.990 ARS
                </p>
                <p className="mt-2 text-sm text-ink-soft" data-id="element-191" data-mp="vm9li74dfr7a">
                  Un solo pago · Sin cuotas ni suscripciones
                </p>
              </div>
            </div>

            <a href={CHECKOUT_URL} target="_blank" rel="noreferrer" className="mt-7 inline-flex w-full items-center justify-center rounded-xl bg-accent px-5 py-4 text-center text-sm font-bold uppercase tracking-wide text-white shadow-lg shadow-accent/20 transition-colors hover:bg-accent-dark sm:text-base" data-id="element-192" data-mp="qnf1x2ykxym4">
              → DESCARGAR EL SISTEMA Y RECUPERAR MI TIEMPO
            </a>

            <div className="mt-5 flex flex-wrap justify-center gap-x-3 gap-y-2 text-center text-xs text-ink-soft" data-id="element-193" data-mp="2sjxgibslmwnm">
              <span className="inline-flex items-center gap-1" data-id="element-194" data-mp="2xcgwffere3vl">
                <LockIcon className="h-3.5 w-3.5" data-id="element-195" data-mp="32a8uys9wso8r" /> Pago 100% seguro
              </span>
              <span aria-hidden="true" data-id="element-196" data-mp="24mrsat6r5npr">•</span>
              <span className="inline-flex items-center gap-1" data-id="element-197" data-mp="24o1r5klfizxg">
                <ZapIcon className="h-3.5 w-3.5" data-id="element-198" data-mp="29ll8wuhc5uu5" /> Acceso en 5 minutos
              </span>
              <span aria-hidden="true" data-id="element-199" data-mp="2el7i8su1mqxo">•</span>
              <span className="inline-flex items-center gap-1" data-id="element-200" data-mp="2ek4pefd5uef4">
                <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-201" data-mp="2jkk5heotu00s" /> Garantía 7 días
              </span>
              <span aria-hidden="true" data-id="element-202" data-mp="3q0metvicbgs9">•</span>
              <span className="inline-flex items-center gap-1" data-id="element-203" data-mp="3pzl63xosr6dp">
                <CreditCardIcon className="h-3.5 w-3.5" data-id="element-204" data-mp="3uyeghh8seh9n" /> Mercado Pago ·
                Tarjeta · Transferencia
              </span>
            </div>
          </article>
          <p className="mt-6 text-center text-base font-bold text-ink" data-id="element-205" data-mp="eyrdqrj8jbcn">
            Si llegaste hasta acá, el ESTUDIOPACK EDICIÓN COMPLETA es para vos.
          </p>
        </SectionReveal>
      </div>
    </section>;
}